<div [hidden]="!showLoader">
  <div class="loader-wrapper">
    <mat-spinner
      mode="indeterminate"
      diameter="60"
      strokeWidth="3"
    ></mat-spinner>
  </div>
</div>
